import React, { useState } from "react";

import LogoSvg from "../../assets/Logo.svg";
import { Page } from "./styles";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { BiGridAlt, BiUserPin, BiUser, BiMenuAltLeft, BiBell, BiCog, BiPlug,BiLayer, BiEnvelope, BiTimer, BiGroup} from "react-icons/bi";
import { Header } from "../../components/Header";
import { useAuth } from "../../hooks/auth";
import { ModalCofirm } from "../../components/ModalCofirm";
import { PermissionComponent } from "../../components/PermissionComponent";

const Navbar = () => {
  const {signOut } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [openModalSignOut,setOpenModalSignOut] = useState(false);
  function toRoute(route: string) {
    navigate(route)
  }
  function toggleLogout() {
    setOpenModalSignOut(!openModalSignOut)
  }
  return (
    <Page>
      {
        openModalSignOut &&
        <ModalCofirm cancel={toggleLogout} confirm={signOut} title={"Tem certeza que deseja sair do sistema?"} />
      }
      <div className="side">
        <img className="logo" src={LogoSvg} alt="logo" />
        <h1>PipeGo - API <BiLayer /></h1>
        <ul>
          <li className={pathname === '/dashboard' ? 'active' : pathname === '/' ? 'active': ''} onClick={()=>toRoute('dashboard')}>
            <BiGridAlt />
            <span>Dashboard</span>
          </li>
          <PermissionComponent type="USER">
          <li className={pathname === '/clients' ? 'active' : ''} onClick={()=>toRoute('clients')}>
            <BiUserPin />
            <span>Clientes</span>
          </li>
          </PermissionComponent>
          <PermissionComponent type="USER">
          <li className={pathname === '/users' ? 'active' : ''} onClick={()=>toRoute('users')}>
            <BiGroup />
            <span>Usuários</span>
          </li>
          </PermissionComponent>
          <li className={pathname === '/profile' ? 'active' : ''} onClick={()=>toRoute('profile')}>
            <BiUser />
            <span>Perfil</span>
          </li>
          <li className={pathname === '/logs' ? 'active' : ''} onClick={()=>toRoute('logs')}>
            <BiMenuAltLeft />
            <span>Logs</span>
          </li>
          <li className={pathname === '/message' ? 'active' : ''} onClick={()=>toRoute('message')}>
            <BiEnvelope />
            <span>Disparo de Mensagens</span>
          </li>
          <li className={pathname === '/queue' ? 'active' : ''} onClick={()=>toRoute('queue')}>
            <BiTimer />
            <span>Fila de Mensagens</span>
          </li>
          <li className={pathname === '/notifications' ? 'active' : ''} onClick={()=>toRoute('dashboard')}>
            <BiBell />
            <span>Notificações</span>
          </li>
          <PermissionComponent type="USER">
          <li className={pathname === '/configurations' ? 'active' : ''} onClick={()=>toRoute('configurations')}>
            <BiCog />
            <span>Configurações</span>
          </li>
          </PermissionComponent>
          <li  onClick={toggleLogout}>
          <BiPlug />
            <span>Sair</span>
          </li>
        </ul>
      </div>
      <div className="main">
        <div className="header">
          <Header />
        </div>
        <div className="content">
          <Outlet />
        </div>
      </div>
    </Page>
  );
};
export { Navbar };
